// extracted by mini-css-extract-plugin
export default {"listItem":"_07Resume_listItem__a5a2H","title":"_07Resume_title__dR-33","extraContent":"_07Resume_extraContent__v-hGw"};